const documentTitles = {
  adminDashboard: 'MFI Admin Dashboard',
  teacherHelpCenter: 'Teacher Help Center',
}

const confirmationModal = {
  upgradeExistingVerify: {
    header: 'This email already has an app account',
    body: 'This person signed up in the TM app and is not yet a verified meditator. Creating this student will take over their existing account and verify them — their app access continues seamlessly with the details you entered.',
    confirmText: 'Create and verify',
  },
  tmattEnroll: {
    header: 'Enroll the teacher into the Digital Course Training?',
  },
  deactivate: {
    header: 'Disable user account',
    body: 'Are you sure you want to disable this user account?',
    confirmText: 'Disable',
  },
  delete: {
    header: 'Delete user account',
    body: 'Are you sure you want to delete this user account?',
    confirmText: 'Delete',
  },
  reinstate: {
    header: 'Reinstate the digital course for this student?',
    body: 'Reinstating your student will give them 7 days of digital course access',
    confirmText: 'Confirm',
  },
  closeWithoutSaving: {
    header: 'Unsaved Changes',
    body: 'Changes that you made will not be saved if you continue.',
    confirmText: 'Continue',
  },
  dcProgress: {
    header: 'Adjust Digital Course position',
    body: {
      noProgress: 'Current position: Not started',
      progress: 'Current position: Day',
    },
    select: {
      label: 'Set Digital Course position to:',
      placeholder: 'Please select a lesson to start your student on',
    },
    confirmText: 'Save',
  },
}

const userActions = {
  clearDevices: 'Clear Devices',
  resend: 'Resend download Instructions',
  disable: 'Disable account',
  progress: 'Adjust Digital Course position',
}

const defaultText = {
  documentTitles,
  confirmationModal,
  userActions,
}
export default defaultText
